import React from 'react';
import Cookies from 'lib/cookies';
import {jwtDecode as _decode, type JwtPayload} from 'lib/jwtDecode';
import {upperFirst} from 'lib/stringUtils';
import HardCapWarningBanner from 'client/components/HardCapWarningBanner/HardCapWarningBanner.react';

import {Dialogue, Button, Text} from '@albert-io/atomic';

interface Props extends PropsWithClassNameRequired {
  handleClose: () => void;
  students: any[];
  syncClassroom: () => void;
  seatsRemaining: number;
  shouldShowHardCapWarning: boolean;
}

export interface DecodedLaunchContextCookie extends JwtPayload {
  context_id: String;
  context_title: String;
  tool_platform_product_family_code: 'Canvas' | 'Schoology';
}

const InviteByLMS = ({
  className,
  handleClose,
  students,
  syncClassroom,
  seatsRemaining,
  shouldShowHardCapWarning
}: Props) => {
  const launchContextCookie = Cookies.get('lti_launch_context');
  const launchContextDecoded = _decode<DecodedLaunchContextCookie>(launchContextCookie as string);
  const lmsPlatformName = launchContextDecoded.tool_platform_product_family_code || 'LMS';
  const lmsClassName = launchContextDecoded.context_title || '';

  return (
    <Dialogue
      hideCloseBtn={false}
      className={className}
      size='m'
      handleClose={handleClose}
      paddingLevel={0}
    >
      <Dialogue.Title size='xs' className='pt-x2 pl-x2'>
        Import from LMS
      </Dialogue.Title>
      {shouldShowHardCapWarning && <HardCapWarningBanner seatsRemaining={seatsRemaining} />}
      <Dialogue.Body className='p-x4'>
        <div className='flex flex-col'>
          <Text bold>{upperFirst(lmsPlatformName)} class:</Text>
          <Text>{lmsClassName}</Text>
          <Text bold className='mt-x5 mb-x2'>
            Students to import:
          </Text>
          {students.map((item) => {
            const isStudent =
              item
                .get('roles')
                .includes('http://purl.imsglobal.org/vocab/lis/v2/membership#Learner') &&
              item.get('fields').get('name') !== 'Test Student';

            if (isStudent) {
              const hasEmail = !!item.get('fields').get('email');
              return (
                // LTI NRPS guarantees user_id on every member
                <div key={item.get('user_id')} className='pb-x1 flex items-center justify-between'>
                  <div className='flex'>
                    <div className='flex flex-col'>
                      <Text>{item.get('fields').get('name')}</Text>
                    </div>
                  </div>
                  {hasEmail ? (
                    <Text color='secondary'>{item.get('fields').get('email')}</Text>
                  ) : (
                    <Text italic>No email address</Text>
                  )}
                </div>
              );
            }
            return null;
          })}
        </div>
      </Dialogue.Body>
      <Dialogue.BtnGroup className='pr-x2 pb-x2'>
        <Button color='secondary' onClick={() => handleClose()}>
          Cancel
        </Button>
        <Button onClick={() => syncClassroom()}>Import</Button>
      </Dialogue.BtnGroup>
    </Dialogue>
  );
};

export default InviteByLMS;
